import { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";

import Role from "constants/role";
import { SettingsSection } from "constants/settings/sections";
import useSettingsSection from "hooks/settings/use-settings-section";
import { useBreakpoints } from "hooks/use-breakpoints";
import { selectLoggedInAgentPermission } from "store/entities/agents";
import { IntegrationsActions, selectLivechatGroupsDataStatus } from "store/entities/integrations";
import { DataStatus } from "store/entities/license";

import { SettingsRoutes } from "../constants";

import { ContactFormsList } from "./ContactFormsList";
import { FormBuilder } from "./form-builder/FormBuilder";
import { NoMobile } from "./form-builder/NoMobile";
import { AddContactForm } from "./legacy/AddContactForm";
import { DuplicateContactForm } from "./legacy/DuplicateContactForm";
import { EditContactForm } from "./legacy/EditContactForm";

const Router: FC = () => {
  const dispatch = useDispatch();
  const agentPermission = useSelector(selectLoggedInAgentPermission);
  const livechatGroupsDataStatus = useSelector(selectLivechatGroupsDataStatus);
  const { isMobile } = useBreakpoints();

  const isAdmin = agentPermission === Role.Owner;

  useSettingsSection(SettingsSection.ContactForms);

  useEffect(() => {
    if (livechatGroupsDataStatus !== DataStatus.Ready) {
      dispatch(IntegrationsActions.fetchLivechatGroups());
    }
  }, [dispatch]);

  return (
    <Switch>
      {isAdmin && <Route path={`${SettingsRoutes.ContactForms}/add`} component={isMobile ? NoMobile : FormBuilder} />}
      {isAdmin && (
        <Route path={`${SettingsRoutes.ContactForms}/duplicate/:id`} component={isMobile ? NoMobile : FormBuilder} />
      )}
      {isAdmin && (
        <Route path={`${SettingsRoutes.ContactForms}/edit/:id`} component={isMobile ? NoMobile : FormBuilder} />
      )}
      {isAdmin && <Route path={`${SettingsRoutes.WidgetForms}/add`} component={AddContactForm} />}
      {isAdmin && <Route path={`${SettingsRoutes.WidgetForms}/duplicate/:id`} component={DuplicateContactForm} />}
      {isAdmin && <Route path={`${SettingsRoutes.WidgetForms}/edit/:id`} component={EditContactForm} />}
      <Route path={SettingsRoutes.ContactForms} component={ContactFormsList} />
      <Redirect to={SettingsRoutes.ContactForms} />
    </Switch>
  );
};

export default Router;
